import angular from 'angular';
import userInfoPanelComponent from './userInfoPanel.component';

let userInfoPanelModule = angular.module('userInfoPanel', []).component('userInfoPanel', userInfoPanelComponent);

export default userInfoPanelModule;



// WEBPACK FOOTER //
// ./app/components/userInfoPanel/userInfoPanel.js